export class MixNoticeFixType {
  static get NewInstall () {
    return 1
  }
  static get ReturnInstall () {
    return 2
  }
  static get MoveInstall () {
    return 3
  }
  static get TryInstall () {
    return 4
  }
  static get AutoMakeNewInstall () {
    return 100
  }
  static get AutoMakeReturnInstall () {
    return 101
  }
  static get AutoMakeMoveInstall () {
    return 102
  }
  static get AutoMakeTryInstall () {
    return 103
  }
  static get RemoveFix () {
    return 201
  }
  static get MoveFix () {
    return 202
  }
  static get RepairFix () {
    return 203
  }
  static get MovieLook () {
    return 206
  }
  static get Photo () {
    return 207
  }
  static get AuthorizeInstall () {
    return 2080
  }
  static get AuthorizeRemove () {
    return 2081
  }
  static get Info () {
    return 209
  }
  static get Prepayment () {
    return 210
  }
  static get Complaint () {
    return 211
  }
  static get TryInstallFix () {
    return 212
  }
  static get TryInstallRepairFix () {
    return 213
  }

  static MixNoticeFixTypeName (MixNoticeFixType) {
    let tmpType = parseInt(MixNoticeFixType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '新裝'
        break
      case 2:
        name = '回裝'
        break
      case 3:
        name = '移機-裝'
        break
      case 4:
        name = '試裝-裝'
        break
      case 100:
        name = '自動產生-新裝'
        break
      case 101:
        name = '自動產生-回裝'
        break
      case 102:
        name = '自動產生-移機(裝)'
        break
      case 103:
        name = '自動產生-試裝(裝)'
        break
      case 201:
        name = '拆機'
        break
      case 202:
        name = '移機-拆'
        break
      case 203:
        name = '維修'
        break
      case 206:
        name = '影像調閱'
        break
      case 207:
        name = '送審拍照'
        break
      case 2080:
        name = '授權-裝機'
        break
      case 2081:
        name = '授權-拆機'
        break
      case 209:
        name = '補資訊'
        break
      case 210:
        name = '預繳'
        break
      case 211:
        name = '客訴'
        break
      case 212:
        name = '試裝-拆'
        break
      case 213:
        name = '試裝-維修'
        break
    }
    return name
  }
}
